import { useCallback, useEffect, useState } from 'react'
import { erc20Abi, formatUnits } from 'viem'
import { getWalletErrorMessage } from '@/utils'
import { useToast } from './use-toast'
import { networks, wagmiConfig } from '@/constants/walletConnectionConfig'
import { getBalance } from '@wagmi/core'
import { useReadContract } from 'wagmi'
import { SECH_TOKEN_DECIMAL, TOKEN_CONTRACT_ADDRESS } from '@/constants'

interface IBalanceParams {
  walletAddress: `0x${string}` | undefined
  userInfoLoading: boolean
}

export const useWalletBalance = ({
  walletAddress,
  userInfoLoading
}: IBalanceParams) => {
  const {
    data: rawBalance,
    isLoading,
    refetch
  } = useReadContract({
    address: TOKEN_CONTRACT_ADDRESS,
    abi: erc20Abi,
    functionName: 'balanceOf',
    args: walletAddress ? [walletAddress] : undefined
  })

  useEffect(() => {
    walletAddress && !isLoading && refetch()
  }, [walletAddress, userInfoLoading])

  const balance = rawBalance
    ? Number(formatUnits(rawBalance, SECH_TOKEN_DECIMAL))
    : 0.0

  return {
    balance: balance || 0,
    balanceLoading: isLoading,
    updateBalance: refetch
  }
}
